import { Component, Inject, OnInit } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PromptDialogComponent } from '../../../../shared/component/prompt-dialog/prompt-dialog.component';
import { timeRangeValidator } from '../../../../shared/custom-validator/time-range-validator';
import { timeFormatValidator } from '../../../../shared/custom-validator/time-format-validator';
import moment from 'moment';
import { DutiesService } from '../services/duties.service';
import { SharedDataService } from '../../../../shared/service/shared-data/shared-data.service';
import { colorPalette, iconList } from '../../../../shared/svg-icons/iconList';
import { SpinnerComponent } from '../../../../shared/component/spinner/spinner.component';
import { TimeConversionService } from '../../../../shared/service/time-conversion.service';
import { noWhitespaceValidator } from 'src/app/shared/custom-validator/white-space-validator';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { UserOrgService } from 'src/app/shared/service/user-org.service';
import { PermissionsService } from 'src/app/services/permissions.service';
import { PERMISSIONS } from 'src/app/constants/permissions.constants';
import {  combineLatest, Subject, takeUntil } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { HelperView } from 'src/app/shared/custom-validator/helper.view';
import { breakTimeRangeValidator } from 'src/app/shared/custom-validator/break-time-range-validator';
import { OrganizationService } from '../../location/services/organization.service';
import { LocationService } from '../../location/services/location.service';

@Component({
  selector: 'app-duty-details',
  templateUrl: './duty-details.component.html',
  styleUrl: './duty-details.component.scss'
})
export class DutyDetailsComponent implements OnInit {
  addDutyForm!: FormGroup;
  selectedIcon: any;
  showWarningMessage: boolean = false;
  dutyTableData: any;
  editData: any;
  dutyIconList: any;
  colorPalette = colorPalette;
  dutyState: any[] = [{ value: true, viewValue: 'Continuous' }, { value: false,  viewValue: 'Non-continuous' }];
  submit: boolean = false;
  nonContinuousDuty: boolean = false;
  selectedDutyState = this.dutyState[0].value;
  selectedDutyType: string = 'DAY';
  breakHourError: boolean = false;
  locationPolicy: any = null;
  orgId: string | null = this._userOrgService.getOrgId() ?? sessionStorage.getItem('orgId');
  canEditDuty:boolean=false;
  maxConsecutiveDaysTooltip: boolean = false;
  permanentNightTooltip: boolean = false;
  private destroy$ = new Subject<void>();
  selectedShiftType: 'FULL_DAY_DUTY' | 'FIRST_HALF_DAY_DUTY' | 'SECOND_HALF_DAY_DUTY' = 'FULL_DAY_DUTY';
  shifts: {
    shiftType: 'FULL_DAY_DUTY' | 'FIRST_HALF_DAY_DUTY' | 'SECOND_HALF_DAY_DUTY',
    firstSlotStartTime?: any,
    firstSlotEndTime?: any,
    secondSlotStartTime?: any,
    secondSlotEndTime?: any,
    shiftDutyId?: string | null
  }[] = [];
  hasChildShift: boolean=false;
  hasExistingHalfDuty: boolean = false;
  isDutyMappedToAnyLocationDepartment: boolean = false;
  selectedTabIndex: number = 0;
  shiftsBackup:any = []
  isAdmin: boolean = false;
  isAppAdmin: boolean = false;
  selectedShifts:any = []
  shiftChecked:boolean[] = [false,false,false]
  dutyTypes:any = ['FULL_DAY_DUTY', 'FIRST_HALF_DAY_DUTY', 'SECOND_HALF_DAY_DUTY']
  private breakHoursInitialised = new WeakSet<FormGroup>();;
    constructor(
      private _formBuilder: FormBuilder,
      public dialogRef: MatDialogRef<DutyDetailsComponent>,
      public dialog: MatDialog,
      @Inject(MAT_DIALOG_DATA) public editFormData: any,
      public dutiesService: DutiesService,
      public sharedDataService: SharedDataService,
      private timeConvertionService: TimeConversionService,
      private _userOrgService : UserOrgService,
      private permissionsService: PermissionsService,
      private translate: TranslateService,
      private orgService: OrganizationService,
        private locationService: LocationService
    ) {}

    ngOnInit() {
      this.dutyIconList = iconList;
      this.loadLocationPolicy();
      this.permissionsService.userPermissions$
      combineLatest([
      this.permissionsService.userPermissions$,
      this.permissionsService.currentPermissions$,
      ])
      .pipe(takeUntil(this.destroy$))
      .subscribe(([userPermissions, currentPermissions]) => {
              this.canEditDuty = this.editFormData?.globalEdit ? userPermissions.includes(PERMISSIONS.GLOBAL_DUTY_MANAGEMENT_WRITE) : currentPermissions.includes(PERMISSIONS.DUTY_MANAGEMENT_WRITE);
              if (this.editFormData?.isEditDutyReadOnlyDepAdmin === true) {
                //if the department id of the deptadmin dont match, then it is readonly user
                this.canEditDuty = false;
              }
               });
      this.isAppAdmin=this.permissionsService.getUserRole() === 'APP_ADMIN'
      if (this.permissionsService.getUserRole &&(
          this.permissionsService.getUserRole() === 'APP_ADMIN' ||
          this.permissionsService.getUserRole() === 'ORG_ADMIN'
        )) {
        this.isAdmin = true;
      } 
      this.addDutyForm = this._formBuilder.group({
        dutyState: [this.selectedDutyState, Validators.required],
        picketDuty: [false],
        managersDuty: [false],
        shifts: this._formBuilder.array([])
      });

      if (this.editFormData?.editData?.isDutyMappedToAnyLocationDepartment) {
        this.isDutyMappedToAnyLocationDepartment = true;
      }

      if (!this.canEditDuty || (this.isDutyMappedToAnyLocationDepartment && !this.isAdmin)) {
        this.addDutyForm.disable();
      }

      if (this.editFormData?.editData) {
        this.editData = this.editFormData.editData;
        this.nonContinuousDuty = !this.editData.continuous;
        this.selectedDutyType = this.editData.dutyType;
        this.populateEditData();
      } else {
        this.addDefaultShift();
      }

      if (this.selectedDutyType === 'DAY') {
        this.initDayShifts();
      }
      this.listenToDutyToggles();
      this.setInitialSelectedTab();
      this.updateBreakHoursValidator();
      this.updateManagersDutyState();
    }

    initDayShifts(): void {
      this.shiftsFormArray.clear();

      for (const type of this.dutyTypes) {
        const existingShift = this.editData?.shifts?.find((s: any) => s.shiftType === type);
        this.shiftsFormArray.push(this.createShiftGroup({
          ...existingShift,
          shiftType: type
        }));
      }
      //select the selected duty type tab
      this.selectedTabIndex = this.dutyTypes.findIndex((shiftType:any) => shiftType === this.editFormData?.selectedShiftType);
      this.selectedTabIndex = Math.max(0, this.selectedTabIndex); // on duty create, selectedIndex is returned as -1, so replace it with 0
      //remove breakHours from left half and right half
      const formArray = this.shiftsFormArray as FormArray;
      formArray?.controls?.forEach((group: any) => {
        const shiftType = group.get('shiftType')?.value;

        if (shiftType !== 'FULL_DAY_DUTY') {
          ['breakHours', 'breakStartTime', 'breakEndTime'].forEach(
            (c) => group.contains(c) && group.removeControl(c)
          );
        }
      });
   // Remove shifts without valid shiftDutyId if not editable
    if (!this.canEditDuty) {
      for (let i = this.shiftsFormArray.length - 1; i >= 0; i--) {
        const shiftGroup = this.shiftsFormArray.at(i);
        const shiftDutyId = shiftGroup.get('shiftDutyId')?.value;
        if (!shiftDutyId) {
          this.shiftsFormArray.removeAt(i);
        }
      }
    }
    }

    //remove unwanted form controls from shifts array of adddutyform and keep them in shiftsBackup
    filterShiftFormArray(){
      // Assume form is your FormGroup
      const shiftsArray = this.addDutyForm.get('shifts') as FormArray;

      if (!shiftsArray || shiftsArray.length < 3) {
        return;
      }

      // Backup array for removed shifts
      this.shiftsBackup = [];

      // Get the last two controls
      const lastTwo = shiftsArray.controls.slice(-2);

      // Store in backup (clone if needed)
      this.shiftsBackup = lastTwo.map(control => control);

      // Remove last two controls from FormArray
      for (let i = 0; i < 2; i++) {
        shiftsArray.removeAt(shiftsArray.length - 1);
      }
    }

    //add the controls stored in shiftsBackup back to shifts array of adddutyform
    revertShiftFormArray(){
      const newShiftArray = this.addDutyForm.get('shifts') as FormArray;
      this.shiftsBackup?.forEach((control:any) => {
        newShiftArray.push(control);
      });
      // Clear the backup after restoring
      this.shiftsBackup = [];
    }

    get shiftsFormArray(): FormArray {
      return this.addDutyForm.get('shifts') as FormArray;
    }

    createShiftGroup(shift: any = {}): FormGroup {
      const isNight = this.selectedDutyType === 'NIGHT';
      const group = this._formBuilder.group({
        shiftDutyId: [shift.shiftDutyId || null], 
        selected: [shift.selected ?? (isNight ? true : this.isShiftSelectedByDefault(shift))],
        shiftType: [shift.shiftType || 'FULL_DAY_DUTY', Validators.required],
        name: [shift.name || ''],
        description: [shift.description || ''],
        icon: [shift.icon || ''],
        iconType: [shift.iconType || ''],
        iconColour: [shift.iconColour || ''],
        code: [shift.code || ''],
        sameAsParent: [shift.sameAsParent ?? false],
        active: [shift.active ?? true],
        isDutyMappedToAnyLocationDepartment: [ shift.isDutyMappedToAnyLocationDepartment ?? false],
        colourCode: [shift.colourCode || null],
        firstSlotStartTime: [ shift.firstSlotStartTime ? this.adjustTimeFormatToLocalFormat(shift.firstSlotStartTime) : ''],
        firstSlotEndTime: [ shift.firstSlotEndTime ? this.adjustTimeFormatToLocalFormat(shift.firstSlotEndTime) : ''],
        secondSlotStartTime: [ shift.secondSlotStartTime ? this.adjustTimeFormatToLocalFormat(shift.secondSlotStartTime) : ''],
        secondSlotEndTime: [ shift.secondSlotEndTime ? this.adjustTimeFormatToLocalFormat(shift.secondSlotEndTime) : '' ],
        inchargeDuty: [shift.inchargeDuty ?? false],
        hours: [shift.hours ?? null],
        breakHours: [shift.breakHours || '', [timeFormatValidator()]],
        breakStartTime: [ shift.breakStartTime ? this.adjustTimeFormatToLocalFormat(shift.breakStartTime) : '' ],
        breakEndTime: [ shift.breakEndTime ? this.adjustTimeFormatToLocalFormat(shift.breakEndTime) : '' ],
        paidBreak: [shift.paidBreak ?? false],
        // Optional: whole number 1–6. Empty is allowed and submitted as null.
        // Pattern rejects 0, negatives, decimals, values > 6 and non-numeric input.
        maxConsecutiveAllocationDays: [ shift.maxConsecutiveAllocationDays ?? null, [Validators.pattern(/^[1-6]$/)] ],
        // Permanent night icon (NIGHT full-day shift only): shown to staff with permanentNightDuty
        permanentNightIconEnabled: [shift.permanentNightIconEnabled ?? false],
        permanentNightIcon: [shift.permanentNightIcon ?? ''],
        permanentNightIconType: [shift.permanentNightIconType ?? ''],
        permanentNightIconColour: [shift.permanentNightIconColour ?? ''],
        permanentNightColourCode: [shift.permanentNightColourCode ?? null],
      });

      // Add conditional validator
      const shouldValidate = () => group.get('selected')?.value || isNight;
      group.setValidators([HelperView.iconOrColorRequired(shouldValidate), this.permanentNightIconValidator]);
      // Subscribe to `selected` value changes and update validators conditionally
      group.get('selected')?.valueChanges.subscribe((isSelected) => {

        const controlsToValidate = ['name', 'code', 'breakHours', 'firstSlotStartTime', 'firstSlotEndTime'];
        controlsToValidate.forEach((controlName) => {
          const control = group?.get(controlName);
          if (control) {
            if (isSelected) {
              if (controlName === 'name') {
                control.setValidators([Validators.required, noWhitespaceValidator()]);
              } 
              else if (controlName === 'breakHours'){
                control.setValidators([this.breakRequiredValidator, timeFormatValidator()]);
              }
              else {
                control.setValidators(Validators.required);
              }
            } else {
              control.clearValidators();
            }
            control.updateValueAndValidity();
          }
        });
        const shiftType = group?.get('shiftType')?.value;
        this.applySlotValidators(group, shiftType, this.nonContinuousDuty, this.selectedDutyType );
        this.updateBreakHoursValidator();
      });

      // Trigger validators on init if selected by default
      if (group?.get('selected')?.value) {
        group?.get('selected')?.updateValueAndValidity({ emitEvent: true });
      }

       // --- break window wiring (FULL_DAY_DUTY only) ---
      if (group.get('shiftType')?.value === 'FULL_DAY_DUTY') {
        ['firstSlotStartTime', 'firstSlotEndTime', 'secondSlotStartTime', 'secondSlotEndTime'].forEach((f) => {
          group.get(f)?.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(() => {
            this.prefillBreakTimes(group);
            this.applyBreakTimeValidators(group);
            this.computeBreakHours(group);
          });
        });
        ['breakStartTime', 'breakEndTime'].forEach((f) => {
          group.get(f)?.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(() => {
            this.applyBreakTimeValidators(group);
            this.computeBreakHours(group);        
          });
        });
        this.prefillBreakTimes(group);
        this.applyBreakTimeValidators(group);
        this.computeBreakHours(group); 
        this.breakHoursInitialised.add(group);     
        this.applyBreakTimeAccess(group);

        // keep the local `hours` control in sync with paid break (display only - backend stays the source of truth)
        ['paidBreak', 'firstSlotStartTime', 'firstSlotEndTime', 'breakStartTime', 'breakEndTime'].forEach((f) =>
          group.get(f)?.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(() => this.syncHours(group))
        );
        this.syncHours(group);
      }

      // Attach the day / night time-window validators from the start, so a range error
      // shows even when times are typed before the tab checkbox is ticked.
      this.applySlotValidators(group, group.get('shiftType')?.value, this.nonContinuousDuty, this.selectedDutyType);

      // Disable all fields if not editable
      if (!this.canEditDuty || (this.isDutyMappedToAnyLocationDepartment && !this.isAdmin)) {
        group.disable();
      }
      return group;
    }

   private updateBreakHoursValidator(): void {
      const shiftArray = this.shiftsFormArray;
      const dutyType = this.addDutyForm.get('dutyType')?.value;
 
      // Find the index of the first matching shift (FULL_DAY_DUTY and selected)
      const index = shiftArray.controls.findIndex(
        (ctrl) =>
          ctrl.get('shiftType')?.value === 'FULL_DAY_DUTY' &&
          ctrl.get('selected')?.value === true
      );
 
      // Use index 0 if not found and dutyType is NIGHT
      const targetIndex = index !== -1 ? index : (dutyType === 'NIGHT' ? 0 : -1);
 
      if (targetIndex === -1) return;
 
      const breakHoursCtrl = this.getBreakHoursCtrl(targetIndex);
      if (!breakHoursCtrl) return;
 
      if (index !== -1 || dutyType === 'NIGHT') {
        breakHoursCtrl.setValidators([this.breakRequiredValidator, timeFormatValidator()]);
      } else {
        breakHoursCtrl.setValidators([timeFormatValidator()]);
      }
 
      breakHoursCtrl.updateValueAndValidity();
    }
    
    getBreakHoursCtrl(index: number): AbstractControl | null {
      return this.shiftsFormArray.at(index).get('breakHours');
    }

    get showBreakHoursInput(): boolean {
      return this.addDutyForm.get('dutyType')?.value === 'NIGHT' ||
       this.selectedTabIndex == 0
    }

    get hasAtLeastOneShiftSelected(): boolean {
      return this.shiftsFormArray.controls.some(ctrl => ctrl.get('selected')?.value);
    }

    get isFullDaySelected(): boolean {
      return this.shiftsFormArray.controls.some(ctrl => {
        const isFullDay = ctrl.get('shiftType')?.value === 'FULL_DAY_DUTY';
        const iconValue = ctrl.get('icon')?.value;
        const iconType = ctrl.get('iconType')?.value;
        const iconColour = ctrl.get('iconColour')?.value;
        const colourCode = ctrl.get('colourCode')?.value;

        return isFullDay && (!!iconValue || !!colourCode || !!iconType ||  !!iconColour);
      });
    }

    setInitialSelectedTab() {
      const filledIndex = this.shiftsFormArray.controls.findIndex(ctrl => {
        const name = ctrl.get('name')?.value;
        const start = ctrl.get('firstSlotStartTime')?.value;
        const end = ctrl.get('firstSlotEndTime')?.value;
        return name || start || end;
      });

      if (filledIndex >= 0) {
        if(this.editFormData?.selectedShiftType){
          this.selectedTabIndex = this.dutyTypes.findIndex((shiftType:any) => shiftType === this.editFormData?.selectedShiftType);
        }
        else{
           this.selectedTabIndex = filledIndex;
        }
      }
    }
    
    onShiftSelectedChange(checked: boolean, index: number): void {
      this.shiftChecked[index] = checked
      if (this.isDutyMappedToAnyLocationDepartment && !this.isAdmin) return;
      const shift = this.shiftsFormArray.at(index);
      if (!checked && !this.isAppAdmin && (shift.get('isDutyMappedToAnyLocationDepartment')?.value)) {
        return;
      }
      shift.get('selected')?.setValue(checked);
      if (shift?.value?.selected) {
       // Add only if it’s not already in the array
        if (!this.selectedShifts.includes(shift?.value?.shiftType)) {
          this.selectedShifts.push(shift?.value?.shiftType);
        }
      } 
      else {
        // Remove if it exists
        this.selectedShifts = this.selectedShifts.filter(
          (type:any) => type !== shift?.value?.shiftType
        );
      }
      this.updateShiftFormArrayValidity()
      this.addDutyForm.markAsDirty();
      this.updateManagersDutyState();
    }

    updateShiftFormArrayValidity() {
      const shiftsArray = this.addDutyForm.get('shifts') as FormArray;

      const shiftTypeIndexMap: Record<string, number> = {
        'FULL_DAY_DUTY': 0,
        'FIRST_HALF_DAY_DUTY': 1,
        'SECOND_HALF_DAY_DUTY': 2
      };

      Object.entries(shiftTypeIndexMap).forEach(([shiftType, index]) => {
        const control = shiftsArray.at(index) as FormGroup;
        if (!control) return;

        // 🔹 1. Handle validity based on selectedShifts
        if (this.selectedShifts.includes(shiftType)) {
          control.setErrors({ selectedShift: true });
        } else {
          control.setErrors(null);
        }

        // 🔹 2. Handle breakHours control based on shiftType
        if (shiftType !== 'FULL_DAY_DUTY') {
          // Remove breakHours if present
          if (control.get('breakHours')) {
            control.removeControl('breakHours');
          }
        }

        control.updateValueAndValidity({ emitEvent: false });
      });
    }

    isShiftSelectedByDefault(shift: any): boolean {
      // In edit mode and shift has ID or name/code/time filled, return true
      if (this.editFormData?.editData) {
        return !!(shift?.id || shift?.name || shift?.code || shift?.breakHours);
      }
      // In create mode, check if values are filled
      return !!(shift?.name || shift?.code || shift?.breakHours || shift?.firstSlotStartTime || shift?.firstSlotEndTime);
    }

    onUseParentIconToggle(index: number): void {
      const currentShift = this.shiftsFormArray.at(index) as FormGroup;
      const useParent = currentShift.get('sameAsParent')?.value;

      if (useParent) {
        // Find Full Day shift
        const fullDayShift = this.shiftsFormArray.controls.find(
          ctrl => ctrl.get('shiftType')?.value === 'FULL_DAY_DUTY'
        );
        if (fullDayShift) {
          const parentIcon = fullDayShift.get('icon')?.value;
          const parentIconType = fullDayShift.get('iconType')?.value;
          const parentIconColour = fullDayShift.get('iconColour')?.value;
          const parentColourCode = fullDayShift.get('colourCode')?.value;
          currentShift.get('icon')?.setValue(parentIcon);
          currentShift.get('iconType')?.setValue(parentIconType);
          currentShift.get('iconColour')?.setValue(parentIconColour);
          currentShift.get('colourCode')?.setValue(parentColourCode);
        }
        currentShift.get('icon')?.disable({ emitEvent: false });
        currentShift.get('iconType')?.disable({ emitEvent: false });
        currentShift.get('iconColour')?.disable({ emitEvent: false });
        currentShift.get('colourCode')?.disable({ emitEvent: false });
      } else {
        currentShift.get('icon')?.enable({ emitEvent: false });
        currentShift.get('iconType')?.enable({ emitEvent: false });
        currentShift.get('iconColour')?.enable({ emitEvent: false });
        currentShift.get('colourCode')?.enable({ emitEvent: false });
      }
      currentShift.updateValueAndValidity();

      this.addDutyForm.markAsDirty();
    }

    populateEditData(): void {
      if (this.editData) {
        this.selectedDutyType = this.editData.dutyType;
        this.addDutyForm.patchValue({
          dutyState: this.editData.continuous,
          // breakHours: this.editData.breakHours,
          picketDuty: this.editData.picketDuty,
          managersDuty: this.editData.managersDuty,
        });

        if (this.selectedDutyType === 'DAY') {
          this.initDayShifts();
        } else if (this.editData.shifts?.length) {
          this.shiftsFormArray.clear();
          this.editData.shifts.forEach((shift: any) => {
            this.shiftsFormArray.push(this.createShiftGroup(shift));
          });
        }

        this.hasExistingHalfDuty = !!this.editData.shifts?.some((s: any) => {
          return (s.shiftType === 'FIRST_HALF_DAY_DUTY' || s.shiftType === 'SECOND_HALF_DAY_DUTY') &&
                 (s.id || s.shiftDutyId || s.name || s.code);
        });

        if (this.hasExistingHalfDuty) {
          this.addDutyForm.get('picketDuty')?.disable();
        }
      }
    }

    updateManagersDutyState() {
      const hasHalfDutySelected = this.shiftsFormArray.controls.some(ctrl => {
        const type = ctrl.get('shiftType')?.value;
        const isSelected = ctrl.get('selected')?.value;
        return (type === 'FIRST_HALF_DAY_DUTY' || type === 'SECOND_HALF_DAY_DUTY') && isSelected;
      });

      const hasHalfDuty = this.hasExistingHalfDuty || hasHalfDutySelected;

      const managersDutyCtrl = this.addDutyForm.get('managersDuty');
      if (managersDutyCtrl) {
        if (hasHalfDuty) {
          managersDutyCtrl.disable({ emitEvent: false });
        } else {
          if (this.canEditDuty && !(this.isDutyMappedToAnyLocationDepartment && !this.isAdmin)) {
            managersDutyCtrl.enable({ emitEvent: false });
          }
        }
      }
    }

    addDefaultShift(): void {
      if (this.shiftsFormArray.length === 0) {
        this.shiftsFormArray.push(this.createShiftGroup());
      }
    }

    getTabLabelByShiftType(type: string): string {
      switch (type) {
        case 'FULL_DAY_DUTY': return this.translate.instant('duties.create_duty_dialog.content.label.full_day');
        case 'FIRST_HALF_DAY_DUTY': return this.translate.instant('duties.create_duty_dialog.content.label.left_half');
        case 'SECOND_HALF_DAY_DUTY': return this.translate.instant('duties.create_duty_dialog.content.label.right_half');
        default: return type;
      }
    }

    getSelectedShiftsForSave(): any[] {
      return this.shiftsFormArray.controls
        .filter(ctrl => ctrl.get('selected')?.value)
        .map(ctrl => ctrl.value);
    }

    getShiftFormGroup(index: number): FormGroup {
      return this.shiftsFormArray.at(index) as FormGroup;
    }

    listenToDutyToggles() {
      this.addDutyForm.get('managersDuty')?.valueChanges.subscribe((value) => {
        if (value) {
          this.addDutyForm.patchValue({ picketDuty: false }, { emitEvent: false });

          // Disable inchargeDuty in all shifts
          this.shiftsFormArray.controls.forEach((ctrl) => {
            ctrl.patchValue({ inchargeDuty: false }, { emitEvent: false });
          });

          this.setFullDayShiftOnly();
        }
      });

      this.addDutyForm.get('picketDuty')?.valueChanges.subscribe((value) => {
        if (value) {
          this.addDutyForm.patchValue( { managersDuty: false }, { emitEvent: false });

          // Disable inchargeDuty in all shifts
          this.shiftsFormArray.controls.forEach((ctrl) => {
            ctrl.patchValue({ inchargeDuty: false }, { emitEvent: false });
          });

          this.setFullDayShiftOnly();
        }
      });

      // Listen to inchargeDuty on each shift in FormArray
      this.shiftsFormArray.controls.forEach((shiftCtrl, index) => {
        shiftCtrl.get('inchargeDuty')?.valueChanges.subscribe((value) => {
          if (value) {
            this.addDutyForm.patchValue({ managersDuty: false,  picketDuty: false }, { emitEvent: false });
          }
        });
      });
    }

    setFullDayShiftOnly() {
      this.selectedShiftType = 'FULL_DAY_DUTY';
  
      // Remove half-day entries
      this.shifts = this.shifts.filter(
        (s) => s.shiftType === 'FULL_DAY_DUTY'
      );
  
      const fullDayShift = this.shifts.find(s => s.shiftType === 'FULL_DAY_DUTY');
      const fullDayFormGroup = this.shiftsFormArray.controls.find(
        ctrl => (ctrl as FormGroup).get('shiftType')?.value === 'FULL_DAY_DUTY'
      ) as FormGroup | undefined;

      if (fullDayShift && fullDayFormGroup) {
        fullDayFormGroup.patchValue({
          firstSlotStartTime: fullDayShift.firstSlotStartTime || null,
          firstSlotEndTime: fullDayShift.firstSlotEndTime || null,
          secondSlotStartTime: fullDayShift.secondSlotStartTime || null,
          secondSlotEndTime: fullDayShift.secondSlotEndTime || null,
        });
      } else if (fullDayFormGroup) {
        fullDayFormGroup.patchValue({
          firstSlotStartTime: null,
          firstSlotEndTime: null,
          secondSlotStartTime: null,
          secondSlotEndTime: null,
        });
      }
    }
  
    onNoClick() {
      this.dialogRef.close();
    }
  
    cancelForm() {
      this.alertUser();
    }
  
    alertUser() {
      if (this.addDutyForm.dirty) {
        this.showWarningMessage = true;
        this.showWarningMessageDialog();
      } else {
        this.onNoClick();
      }
    }
    showWarningMessageDialog() {
      const dialogRef: MatDialogRef<PromptDialogComponent> = this.dialog.open(
        PromptDialogComponent,
        {
          width: '536px',
          height: '338px',
          disableClose: true,
          data: {
            iconName: 'info',
            title: 'prompt_dialog.title',
            message: 'prompt_dialog.content',
            buttons: ['prompt_dialog.back_btn', 'prompt_dialog.ok_btn'],
            buttonName: ['Back', 'OK'],
          },
        }
      );
      dialogRef.componentInstance.buttonClicked.subscribe(
        (buttonName: string) => {
          if (buttonName === 'OK') {
            dialogRef.close();
            this.onNoClick();
          } else if (buttonName === 'Back') {
            dialogRef.close();
          }
        }
      );
    }
  
    adjustTimeFormatToLocalFormat(editTime: string): string {
      const is12HourFormat = /[ap]m/i.test(editTime);
  
      // Get the locale-specific time format
      const localeFormat = moment.localeData().longDateFormat('LT');
  
      if (is12HourFormat) {
        // Convert 12-hour format to 24-hour format
        return moment(editTime, 'h:mm A').format('HH:mm');
      } else {
        // Convert 24-hour format to 12-hour format
        return moment(editTime, 'HH:mm').format(localeFormat);
      }
    }
  
    parseTimeString(timeString: string): Date {
      const [time, modifier] = timeString?.split(' ');
      let [hours, minutes] = time?.split(':')?.map(Number);
  
      if (modifier === 'PM' && hours !== 12) {
        hours += 12;
      } else if (modifier === 'AM' && hours === 12) {
        hours = 0;
      }
  
      const date = new Date();
      date.setHours(hours, minutes, 0, 0);
  
      return date;
    }
  
    parseBreakHours(breakHours: string): number {
      const hoursMatch = breakHours?.match(/(\d+)h/);
      const minutesMatch = breakHours?.match(/(\d+)m/);
  
      const hours = hoursMatch ? parseInt(hoursMatch[1], 10) : 0;
      const minutes = minutesMatch ? parseInt(minutesMatch[1], 10) : 0;
  
      return hours * 60 + minutes;
    }
  
    getTimeDifferenceInMinutes(startTime: string, endTime: string): number {
      const start = this.parseTimeString(startTime);
      const end = this.parseTimeString(endTime);
  
      let diff = end?.getTime() - start?.getTime();
  
      // If the difference is negative, it means the end time is on the next day
      if (diff < 0) {
        diff += 24 * 60 * 60 * 1000; // Add 24 hours in milliseconds
      }
  
      return diff / (1000 * 60); // Return difference in minutes
    }
  
   submitForm() {
    if (this.isNonCompliant) return;
    this.submit = true;
    const form = this.addDutyForm.getRawValue();
    const selectedShifts = this.shiftsFormArray.controls
      .filter((group) => group.get('selected')?.value)
      .map((group) => group.getRawValue());
    if (!form || selectedShifts.length === 0) return;

    const finalResult: any = {
      organisationId: this.orgId,
      // breakHours: form.breakHours,
      continuous: !this.nonContinuousDuty,
      dutyType: this.selectedDutyType,
      picketDuty: form.picketDuty,
      managersDuty: form.managersDuty
    };

    if (this.dutyTableData) {
      finalResult.memberTypes = this.dutyTableData;
    }

    const convert = (time: string) =>
      time ? this.timeConvertionService.convertToTwelveHourFormat(time) : null;

    // 🌓 NIGHT duty logic
    if (this.selectedDutyType === 'NIGHT') {
      const fullDayShift = selectedShifts.find(s => s.shiftType === 'FULL_DAY_DUTY') || selectedShifts[0];
      const shift: any = {
        shiftType: 'FULL_DAY_DUTY',
        firstSlotStartTime: convert(fullDayShift?.firstSlotStartTime),
        firstSlotEndTime: convert(fullDayShift?.firstSlotEndTime),
        secondSlotStartTime: this.nonContinuousDuty ? convert(fullDayShift?.secondSlotStartTime) : null,
        secondSlotEndTime: this.nonContinuousDuty ? convert(fullDayShift?.secondSlotEndTime) : null,
        inchargeDuty: fullDayShift?.inchargeDuty,
        active: fullDayShift?.active,
        icon: fullDayShift.icon,
        iconType: fullDayShift.iconType,
        iconColour: fullDayShift.iconColour,
        colourCode: fullDayShift.colourCode,
        code: fullDayShift.code,
        name: fullDayShift.name,
        description: fullDayShift.description,
        sameAsParent: fullDayShift.sameAsParent,
        breakHours: fullDayShift.breakHours,
        breakStartTime: convert(fullDayShift?.breakStartTime),
        breakEndTime: convert(fullDayShift?.breakEndTime),
        paidBreak: !this.nonContinuousDuty && !!fullDayShift?.paidBreak,
        maxConsecutiveAllocationDays: fullDayShift?.maxConsecutiveAllocationDays ? Number(fullDayShift.maxConsecutiveAllocationDays) : null,
        ...this.mapPermanentNightIcon(fullDayShift, this.isPermanentNightApplicable),
      };

      if (this.editFormData?.buttonName === 'Update') {
        const matched = this.editData?.shifts?.find(
          (s: any) => s.shiftType === 'FULL_DAY_DUTY' && s.shiftDutyId
        );
        if (matched) {
          shift.shiftDutyId = matched.shiftDutyId;
        }
      }

      finalResult.shifts = [shift];
    }

    // ☀️ DAY duty logic
    else if (this.selectedDutyType === 'DAY') {
      finalResult.shifts = selectedShifts.map((shift: any) => {
        const shiftObj: any = {
          shiftType: shift.shiftType,
          firstSlotStartTime: convert(shift.firstSlotStartTime),
          firstSlotEndTime: convert(shift.firstSlotEndTime),
          secondSlotStartTime: convert(shift.secondSlotStartTime),
          secondSlotEndTime: convert(shift.secondSlotEndTime),
          icon: shift.icon,
          iconType: shift.iconType,
          iconColour: shift.iconColour,
          colourCode: shift.colourCode,
          code: shift.code,
          name: shift.name,
          description: shift.description,
          sameAsParent: shift.sameAsParent,
          active: shift.active,
          inchargeDuty: shift.inchargeDuty,
          breakHours: shift?.breakHours,
          breakStartTime: shift.shiftType === 'FULL_DAY_DUTY' ? convert(shift.breakStartTime) : null,
          breakEndTime: shift.shiftType === 'FULL_DAY_DUTY' ? convert(shift.breakEndTime) : null,
          paidBreak: shift.shiftType === 'FULL_DAY_DUTY' && !this.nonContinuousDuty && !!shift.paidBreak,
          maxConsecutiveAllocationDays: shift.maxConsecutiveAllocationDays ? Number(shift.maxConsecutiveAllocationDays) : null,
          ...this.mapPermanentNightIcon(shift, false), // NIGHT-only: always false / null for DAY
        };

        if (this.editFormData?.buttonName === 'Update') {
          const matchingOldShift = this.editData?.shifts?.find(
            (oldShift: any) => oldShift.shiftType === shift.shiftType
          );
          if (matchingOldShift?.shiftDutyId) {
            shiftObj.shiftDutyId = matchingOldShift.shiftDutyId;
          }
        }

        return shiftObj;
      });
    }
    
    // Check if new/updated duty is In-Charge
    const isNewDutyInCharge = finalResult.shifts?.some((s: any) => s.inchargeDuty === true);

    if (isNewDutyInCharge) {
      const spinnerRef = this.dialog.open(SpinnerComponent, {
        disableClose: true,
        panelClass: 'transparent-dialog',
      });
      let dutiesParm = {
        id: this.orgId,
        activeOnly: false
      };
      this.orgService.fetchOrgDuty(this.orgId, dutiesParm).subscribe({
        next: (dutiesData: any) => {
          if (dutiesData.status === 200) {
            const dutiesList = dutiesData.body || [];
            const existingInChargeDuty = dutiesList.find((d: any) => d.inchargeDuty === true);
            const currentDutyId = this.editData?.shifts?.[0]?.shiftDutyId || this.editData?.dutyId || this.editData?.id;
            const existingInChargeDutyId = existingInChargeDuty?.dutyId || existingInChargeDuty?.id;
            if (existingInChargeDuty && existingInChargeDutyId && existingInChargeDutyId !== currentDutyId) {
              spinnerRef.close();
              this.showInChargeConfirmationDialog(existingInChargeDuty.name, () => {
                this.saveOrUpdateDuty(finalResult);
              });
            } else {
              this.saveOrUpdateDuty(finalResult, spinnerRef);
            }
          } else {
            spinnerRef.close();
            this.saveOrUpdateDuty(finalResult);
          }
        },
        error: () => {
          spinnerRef.close();
          this.saveOrUpdateDuty(finalResult);
        }
      });
    } else {
      this.saveOrUpdateDuty(finalResult);
    }
  }

  showInChargeConfirmationDialog(existingDutyName: string, onConfirm: () => void) {
    const dialogRef: MatDialogRef<PromptDialogComponent> = this.dialog.open(
      PromptDialogComponent,
      {
        width: '536px',
        height: '380px',
        disableClose: true,
        data: {
          iconName: 'info',
          title: 'duties.in_charge_confirm.title',
          message: 'duties.in_charge_confirm.message',
          translationParams: { name: existingDutyName },
          buttons: ['prompt_dialog.back_btn', 'prompt_dialog.ok_btn'],
          buttonName: ['Back', 'OK'],
        },
      }
    );
    dialogRef.componentInstance.buttonClicked.subscribe(
      (buttonName: string) => {
        if (buttonName === 'OK') {
          dialogRef.close();
          onConfirm();
        } else if (buttonName === 'Back') {
          dialogRef.close();
        }
      }
    );
  }

  saveOrUpdateDuty(finalResult: any, existingSpinnerRef?: any) {
    const spinnerRef = existingSpinnerRef || this.dialog.open(SpinnerComponent, {
      disableClose: true,
      panelClass: 'transparent-dialog',
    });

    if (this.editFormData.buttonName === 'Create') {
      this.dutiesService.saveDuty(finalResult).subscribe({
        next: (data: any) => {
          if (data.status === 201) {
            this.dialogRef.close('success');
            spinnerRef.close();
            this.addDutyForm.reset();
          }
        },
        error: () => {
          spinnerRef.close();
        }
      });
    } else if (this.editFormData.buttonName === 'Update') {
      let shiftDutyIdToUpdate = this.editData?.shifts?.find(
        (s: any) => s.shiftType === 'FULL_DAY_DUTY' && s.shiftDutyId
      )?.shiftDutyId;

      if (!shiftDutyIdToUpdate) {
        shiftDutyIdToUpdate = this.editData?.shifts?.find(
          (s: any) => s.shiftDutyId
        )?.shiftDutyId;
      }

      if (!shiftDutyIdToUpdate) {
        console.error('No valid shiftDutyId found for update.');
        spinnerRef.close();
        return;
      }
      this.dutiesService.updateDuty(shiftDutyIdToUpdate, finalResult).subscribe({
        next: (data: any) => {
          if (data.status === 204) {
            this.dialogRef.close('success');
            spinnerRef.close();
            this.addDutyForm.reset();
          }
        },
        error: () => {
          spinnerRef.close();
        }
      });
    }
  }
  
  breakHrVal(){
    const form = this.addDutyForm.getRawValue();
    const breakInMinutes = this.parseBreakHours(form?.breakHours || '00:00');
    //  Skip break hour check for half-day duties
    if (this.selectedDutyType === 'DAY' &&
      (this.selectedShiftType === 'FIRST_HALF_DAY_DUTY' || this.selectedShiftType === 'SECOND_HALF_DAY_DUTY')) {
      this.breakHourError = false;//no breakhr validation for left and right half
      return;
      }
    let difference = 0;

    const convert = (time: string) =>
    time ? this.timeConvertionService.convertToTwelveHourFormat(time) : null;
    const getDiff = (start: string, end: string) =>
    start && end
      ? this.getTimeDifferenceInMinutes(convert(start), convert(end))
      : 0;

    // Only show break hour error if both required slots are entered
    let requiredSlotsFilled = false;
    if (this.selectedDutyType === 'DAY') {
      switch (this.selectedShiftType) {
        case 'FULL_DAY_DUTY':
          const firstHalfFilled = !!form.firstSlotStartTime && !!form.firstSlotEndTime;
          const secondHalfFilled = this.nonContinuousDuty
            ? !!form.secondSlotStartTime && !!form.secondSlotEndTime
            : true;
          requiredSlotsFilled = firstHalfFilled && secondHalfFilled;
          const firstHalf = getDiff(
            form.firstSlotStartTime,
            form.firstSlotEndTime
          );
          const secondHalf = this.nonContinuousDuty
            ? getDiff(form.secondSlotStartTime, form.secondSlotEndTime)
            : 0;
          difference = (firstHalf + secondHalf) / 2;
          break;
      }
    } else {
    // NIGHT or others
      const firstFilled = !!form.firstSlotStartTime && !!form.firstSlotEndTime;
      const secondFilled = this.nonContinuousDuty
        ? !!form.secondSlotStartTime && !!form.secondSlotEndTime
        : true;
      requiredSlotsFilled = firstFilled && secondFilled;
    const first = getDiff(form.firstSlotStartTime, form.firstSlotEndTime);
    const second = this.nonContinuousDuty
      ? getDiff(form.secondSlotStartTime, form.secondSlotEndTime)
      : 0;
    difference = (first + second) / 2;
  }
    if (requiredSlotsFilled) {
      this.breakHourError = breakInMinutes > difference;
    } else {
      this.breakHourError = false;
    }
  }
  
  convertTimeFormat(timeValue: string): any {
    // Check if the value is in "2d" format
    const match = timeValue.match(/^(\d+)d$/);
    if (match) {
      // Convert days to hours (1 day = 8 hours)
      return `${parseInt(match[1], 10) * 8}h`;
    } else {
      return timeValue;
    }
  }

  onDutyStateChange(event: any) {
    const isContinuous = event.value === true;
    this.nonContinuousDuty = !isContinuous;

    // Update each shift's validation according to updated duty state
    const shiftArray = this.shiftsFormArray; // or whatever you call it

    shiftArray.controls.forEach((control, index) => {
      const group = control as FormGroup;
      const isSelected = group.get('selected')?.value;
      const shiftType = group.get('shiftType')?.value;

      if (isSelected) {
        this.applySlotValidators(group, shiftType, this.nonContinuousDuty, this.selectedDutyType);
      } else {
        this.clearAllSlotValidators(group);
      }
    });

    const fullDayGroup = this.shiftsFormArray.controls.find(
      (c) => c.get('shiftType')?.value === 'FULL_DAY_DUTY'
    ) as FormGroup | undefined;
    if (fullDayGroup) {
      // Paid break only exists on continuous duties - the gap of a non-continuous duty is never paid
      if (this.nonContinuousDuty) {
        fullDayGroup.get('paidBreak')?.setValue(false, { emitEvent: false });
      }
      this.prefillBreakTimes(fullDayGroup);
      this.applyBreakTimeValidators(fullDayGroup);
      this.computeBreakHours(fullDayGroup);    
      this.applyBreakTimeAccess(fullDayGroup);
    }

    this.onShiftTypeChange('FULL_DAY_DUTY');
    this.onBtnToggleChange(this.selectedDutyType);
  }

  private clearAllSlotValidators(group: FormGroup): void {
    ['firstSlotStartTime', 'firstSlotEndTime', 'secondSlotStartTime', 'secondSlotEndTime'].forEach(field => {
      const ctrl = group.get(field);
      ctrl?.clearValidators();
      ctrl?.updateValueAndValidity();
    });
  }

  onBtnToggleChange(event: any, action?: string , initialLoad: boolean = false) {
    this.selectedDutyType = event;
    this.resetPermanentNightIconIfNotApplicable();
    if (!initialLoad) {
    this.setFullDayShiftOnly();//whenever the dutyType changes,set the shiftType to FULL_DAY_DUTY      
    }
    if (action !== 'edit') {
      this.addDutyForm.markAsDirty();
    }
    const shift = this.shiftsFormArray.at(0);
    if (this.selectedDutyType === 'NIGHT'){
      shift.get('selected')?.setValue(true);
      this.filterShiftFormArray()
    }
    else if (this.selectedDutyType === 'DAY' && this.shiftsBackup?.length && (!this.addDutyForm.getRawValue()?.picketDuty && !this.addDutyForm.value?.managersDuty)) {
      if(this.shiftChecked[0] === false){
        shift.get('selected')?.setValue(false); // remove default tab selection in DAY
      }
      this.revertShiftFormArray()
    }
    const shiftsArray = this.addDutyForm?.get('shifts') as FormArray;
    if (!shiftsArray) return;

    shiftsArray.controls.forEach((group: AbstractControl) => {
      const shiftGroup = group as FormGroup;
      const shiftType = shiftGroup.get('shiftType')?.value;

      const nameCtrl = shiftGroup.get('name');
      const codeCtrl = shiftGroup.get('code');
      const iconCtrl = shiftGroup.get('icon');
      const iconTypeCtrl = shiftGroup.get('iconType');
      const iconColourCtrl = shiftGroup.get('iconColour');
      const colourCodeCtrl = shiftGroup.get('colourCode');
      const breakHoursCtrl = shiftType === 'FULL_DAY_DUTY' ? shiftGroup?.get('breakHours') : null;

      if (this.selectedDutyType === 'NIGHT') {
        nameCtrl?.setValidators([Validators.required, noWhitespaceValidator()]);
        codeCtrl?.setValidators([Validators.required]);

        // One-of-four validator
        const oneOfFourRequired = () => {
          const iconValue = iconCtrl?.value?.trim();
          const iconTypeValue = iconTypeCtrl?.value?.trim();
          const iconColourValue = iconColourCtrl?.value?.trim();
          const colourCodeValue = colourCodeCtrl?.value?.trim();
          return (iconValue || iconTypeValue || iconColourValue || colourCodeValue)
            ? null
            : { oneRequired: true };
        };

        iconCtrl?.setValidators(oneOfFourRequired);
        iconTypeCtrl?.setValidators(oneOfFourRequired);
        iconColourCtrl?.setValidators(oneOfFourRequired);
        colourCodeCtrl?.setValidators(oneOfFourRequired);

        breakHoursCtrl?.setValidators([this.breakRequiredValidator, timeFormatValidator()]);
      } else {
        nameCtrl?.clearValidators();
        codeCtrl?.clearValidators();
        iconCtrl?.clearValidators();
        iconTypeCtrl?.clearValidators();
        iconColourCtrl?.clearValidators();
        colourCodeCtrl?.clearValidators();
        breakHoursCtrl?.clearValidators();
      }

      nameCtrl?.updateValueAndValidity();
      codeCtrl?.updateValueAndValidity();
      iconCtrl?.updateValueAndValidity();
      iconTypeCtrl?.updateValueAndValidity();
      iconColourCtrl?.updateValueAndValidity();
      colourCodeCtrl?.updateValueAndValidity();
      breakHoursCtrl?.updateValueAndValidity();

      this.applySlotValidators(shiftGroup, shiftType, this.nonContinuousDuty, this.selectedDutyType);
    });
   
    if (this.selectedDutyType === 'NIGHT') {
      this.shiftsValidation('set-validators');
    } else {
      this.shiftsValidation('clear-validators');
    }
    if (this.selectedDutyType === 'DAY') {
      this.shiftsValidation('set-validators');
    }
    const fdGroup = this.shiftsFormArray.controls.find(
      (c) => c.get('shiftType')?.value === 'FULL_DAY_DUTY'
    ) as FormGroup | undefined;
    if (fdGroup) this.applyBreakTimeValidators(fdGroup);
    this.updateManagersDutyState();
  }
  
  onToggleChange(event: MatSlideToggleChange, action: string): void {
    const isDayDuty = this.selectedDutyType === 'DAY' && 
                      !this.addDutyForm.get('managersDuty')?.value && 
                      !this.addDutyForm.get('picketDuty')?.value;

    const shiftIndex = isDayDuty ? this.selectedTabIndex : 0;
    const shiftGroup = this.shiftsFormArray.at(shiftIndex) as FormGroup;

    if (!shiftGroup) return;

    if (action === 'active') {
      shiftGroup.patchValue({ active: event.checked });
    } else if (action === 'inchargeDuty') {
      shiftGroup.patchValue({ inchargeDuty: event.checked });
    }
    if (this.editFormData?.editData) {
      this.addDutyForm.markAsDirty();
    }
  }
  
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private setHalfDaySlotValues(group: FormGroup, values: Partial<Record<string, string>>) {
    group.patchValue(values);
    if(this.canEditDuty){//to fix the issue of confirmation popup showing for read only modes
    this.markControlsDirtyTouched(group, Object.keys(values));
  }
  }

  onShiftTypeChange(type: 'FULL_DAY_DUTY' | 'FIRST_HALF_DAY_DUTY' | 'SECOND_HALF_DAY_DUTY') {
    const isContinuous = !this.nonContinuousDuty;

    // Target group: shift that is being changed
    const targetGroup = this.shiftsFormArray.controls.find(ctrl =>
      (ctrl as FormGroup).get('shiftType')?.value === type
    ) as FormGroup | undefined;

    // Reference group: FULL_DAY_DUTY shift
    const fullDayGroup = this.shiftsFormArray.controls.find(ctrl =>
      (ctrl as FormGroup).get('shiftType')?.value === 'FULL_DAY_DUTY'
    ) as FormGroup | undefined;

    if (!targetGroup || !fullDayGroup) return;

    const getVal = (key: string) => fullDayGroup.get(key)?.value || '';
    const isEmpty = (controlName: string) => !targetGroup.get(controlName)?.value;

    if (type === 'FIRST_HALF_DAY_DUTY') {
      if (isContinuous) {
        if (isEmpty('firstSlotStartTime') && isEmpty('firstSlotEndTime')) {
          const start = this.getTimeFromHHMM(getVal('firstSlotStartTime'));
          const end = this.getTimeFromHHMM(getVal('firstSlotEndTime'));
          const breakMinutes = this.parseBreakHours(this.addDutyForm?.value?.breakHours || '00:00');
          const totalMs = end.getTime() - start.getTime() - breakMinutes * 60 * 1000;
          const halfEnd = new Date(start.getTime() + totalMs / 2);

          const values = {
            firstSlotStartTime: getVal('firstSlotStartTime'),
            firstSlotEndTime: this.formatDateToHHMM(halfEnd),
            secondSlotStartTime: '',
            secondSlotEndTime: ''
          };
          this.setHalfDaySlotValues(targetGroup, values);
        }
      } else {
        if (isEmpty('firstSlotStartTime') && isEmpty('firstSlotEndTime')) {
          targetGroup.patchValue({
            firstSlotStartTime: getVal('firstSlotStartTime'),
            firstSlotEndTime: getVal('firstSlotEndTime'),
            secondSlotStartTime: '',
            secondSlotEndTime: ''
          });
        }
      }
    }

    if (type === 'SECOND_HALF_DAY_DUTY') {
      if (isContinuous) {
        if (isEmpty('secondSlotStartTime') && isEmpty('secondSlotEndTime')) {
          const start = this.getTimeFromHHMM(getVal('firstSlotStartTime'));
          const end = this.getTimeFromHHMM(getVal('firstSlotEndTime'));
          const breakMinutes = this.parseBreakHours(this.addDutyForm?.value?.breakHours || '00:00');
          const totalMs = end.getTime() - start.getTime() - breakMinutes * 60 * 1000;
          const halfStart = new Date(start.getTime() + totalMs / 2);

          const values = {
            secondSlotStartTime: this.formatDateToHHMM(halfStart),
            secondSlotEndTime: getVal('firstSlotEndTime'),
            firstSlotStartTime: '',
            firstSlotEndTime: ''
          };
          this.setHalfDaySlotValues(targetGroup, values);
        }
      } else {
        if (isEmpty('secondSlotStartTime') && isEmpty('secondSlotEndTime')) {
          targetGroup.patchValue({
            secondSlotStartTime: getVal('secondSlotStartTime'),
            secondSlotEndTime: getVal('secondSlotEndTime'),
            firstSlotStartTime: '',
            firstSlotEndTime: ''
          });
        }
      }
    }

    if (type === 'FULL_DAY_DUTY' && isContinuous) {
      targetGroup.patchValue({
        secondSlotStartTime: '',
        secondSlotEndTime: ''
      });
    }

    this.applySlotValidators(targetGroup, type, this.nonContinuousDuty, this.selectedDutyType);
  }

  markControlsDirtyTouched(group: FormGroup, keys: string[]) {
    keys.forEach(key => {
      const ctrl = group.get(key);
      if (ctrl) {
        ctrl.markAsDirty();
        ctrl.markAsTouched();
      }
    });
  }
  
  getTimeFromHHMM(timeStr: string): Date {
    const [hours, minutes] = timeStr.split(':').map(Number);
    const now = new Date();
    now.setHours(hours, minutes, 0, 0);
    return new Date(now);
  }
  
  formatDateToHHMM(date: Date): string {
    const h = date.getHours().toString().padStart(2, '0');
    const m = date.getMinutes().toString().padStart(2, '0');
    return `${h}:${m}`;
  }
  
  resetControl(controlName: string): void {
    const control = this.addDutyForm.get(controlName);
    if (control) {
      control.reset(); // Resets value, touched, dirty, errors
      control.clearValidators();
      control.updateValueAndValidity({ onlySelf: true });
    }
  }

  onTabChange(index: number) {
    this.selectedTabIndex = index;
    const shiftGroup = this.shiftsFormArray.at(index) as FormGroup;
    const shiftType = shiftGroup.get('shiftType')?.value;
    this.onShiftTypeChange(shiftType)
  }

  getActiveValue(): boolean {
    const isDayDuty = this.selectedDutyType === 'DAY';
    const isManagerOrPicket = this.addDutyForm.get('managersDuty')?.value || this.addDutyForm.get('picketDuty')?.value;
    if (isDayDuty && !isManagerOrPicket) {
      return this.shiftsFormArray.at(this.selectedTabIndex)?.get('active')?.value ?? true;
    } else {
      return this.shiftsFormArray.at(0)?.get('active')?.value ?? true;
    }
  }

  private applySlotValidators(
    group: FormGroup,
    shiftType: 'FULL_DAY_DUTY' | 'FIRST_HALF_DAY_DUTY' | 'SECOND_HALF_DAY_DUTY',
    nonContinuousDuty: boolean,
    dutyType: string
  ) {
    const isSelected = group.get('selected')?.value === true;
    const isNight = dutyType === 'NIGHT';

    const slotControls = {
      firstStart: group.get('firstSlotStartTime'),
      firstEnd: group.get('firstSlotEndTime'),
      secondStart: group.get('secondSlotStartTime'),
      secondEnd: group.get('secondSlotEndTime'),
    };

    // Clear all validators first
    Object.values(slotControls).forEach(control => {
      control?.clearValidators();
      control?.updateValueAndValidity();
    });

    const applyValidators = (controlNames: string[], validators: ValidatorFn[]) => {
      controlNames.forEach((fieldName) => {
        const control = group.get(fieldName);
        if (!control) return;
        const valueExists = !!control.value;
        const rules = [...validators];

        // Night shifts: always require the fields
        if (isNight || isSelected || valueExists) {
          rules.unshift(Validators.required);
        }

        control.setValidators(rules);
        control.updateValueAndValidity();
      });
    };

    const addTimeRange = ( field1: string, field2: string, controlNames: string[] ) => {
      applyValidators(controlNames, [  timeRangeValidator(field1, field2, dutyType, nonContinuousDuty) ]);
    };

    const addMultiTimeRanges = ( controlName: string, ranges: [string, string, string?][] ) => {
      const validators: ValidatorFn[] = [];

      for (const [from, to, startField] of ranges) {
        validators.push( timeRangeValidator(from, to, dutyType, nonContinuousDuty, startField) );
      }

      const control = group.get(controlName);
      if (control) {
        const valueExists = !!control.value;
        const rules = [...validators];

        if (isNight || isSelected || valueExists) {
          rules.unshift(Validators.required);
        }

        control.setValidators(rules);
        control.updateValueAndValidity();
      }
    };

    const basicFirstRange: [string, string] = ['firstSlotStartTime', 'firstSlotEndTime'];
    const secondRange: [string, string] = ['secondSlotStartTime', 'secondSlotEndTime'];
    const crossRange: [string, string, string] = ['firstSlotEndTime', 'secondSlotStartTime', 'firstSlotEndTime'];

    // Apply validators based on type
    if (isNight) {
      if (!nonContinuousDuty) {
        addTimeRange(...basicFirstRange, ['firstSlotStartTime', 'firstSlotEndTime']);
      } else {
        addTimeRange(...basicFirstRange, ['firstSlotStartTime']);
        addMultiTimeRanges('firstSlotEndTime', [basicFirstRange, crossRange]);
        addMultiTimeRanges('secondSlotStartTime', [secondRange, crossRange]);
        addMultiTimeRanges('secondSlotEndTime', [secondRange, crossRange]);
      }
      return;
    }

    if (shiftType === 'FULL_DAY_DUTY') {
      if (nonContinuousDuty) {
        addTimeRange(...basicFirstRange, ['firstSlotStartTime']);
        addMultiTimeRanges('firstSlotEndTime', [basicFirstRange, crossRange]);
        addMultiTimeRanges('secondSlotStartTime', [secondRange, crossRange]);
        addMultiTimeRanges('secondSlotEndTime', [secondRange, crossRange]);
      } else {
        addTimeRange(...basicFirstRange, ['firstSlotStartTime', 'firstSlotEndTime']);
      }
    } else if (shiftType === 'FIRST_HALF_DAY_DUTY') {
      addTimeRange(...basicFirstRange, ['firstSlotStartTime', 'firstSlotEndTime']);
    } else if (shiftType === 'SECOND_HALF_DAY_DUTY') {
      addTimeRange(...secondRange, ['secondSlotStartTime', 'secondSlotEndTime']);
    }
  }

  onIconColorChange(selection:  { icon: string | null; color: string | null; iconType: string | null; iconColour: string | null }, shiftType: string): void {
    const shiftGroup = this.shiftsFormArray.controls.find(ctrl => ctrl.get('shiftType')?.value === shiftType);
    if (shiftGroup) {
      shiftGroup.get('icon')?.setValue(selection.icon);
      shiftGroup.get('iconType')?.setValue(selection.iconType);
      shiftGroup.get('iconColour')?.setValue(selection.iconColour);
      shiftGroup.get('colourCode')?.setValue(selection.color);
      shiftGroup.updateValueAndValidity(); // Trigger validation
      this.addDutyForm.markAsDirty();
    }
    if (shiftType === 'FULL_DAY_DUTY') {
      this.shiftsFormArray?.controls?.forEach(ctrl => {
        if (
          ctrl.get('shiftType')?.value !== shiftType && // exclude the updated one
          ctrl.get('sameAsParent')?.value === true
        ) {
          ctrl.get('icon')?.setValue(selection.icon);
          ctrl.get('iconType')?.setValue(selection.iconType);
          ctrl.get('iconColour')?.setValue(selection.iconColour);
          ctrl.get('colourCode')?.setValue(selection.color);
          ctrl.updateValueAndValidity();
        }
      });
    }
  }

  shiftsValidation(action:string){
     const shiftsArray = this.addDutyForm?.get('shifts') as FormArray;
      shiftsArray?.controls?.forEach((group: AbstractControl) => {
      const shiftGroup = group as FormGroup;
      const shiftType = shiftGroup.get('shiftType')?.value;
      const nameCtrl = shiftGroup.get('name');
      const codeCtrl = shiftGroup.get('code');
      const iconCtrl = shiftGroup.get('icon');
      const hoursCtrl = shiftGroup?.get('breakHours');
      if(action === 'clear-validators'){
        // this.revertShiftFormArray()
        nameCtrl?.clearValidators();
        codeCtrl?.clearValidators();
        iconCtrl?.clearValidators();
        hoursCtrl?.clearValidators();
      }
      else if(action === 'set-validators' && shiftGroup.get('selected')?.value === true){
        // const shift = this.shiftsFormArray.at(0);
        // shift?.get('selected')?.setValue(true);
        nameCtrl?.setValidators([Validators.required, noWhitespaceValidator()]);
        codeCtrl?.setValidators([Validators.required]);
        iconCtrl?.setValidators([Validators.required]);
        hoursCtrl?.setValidators([this.breakRequiredValidator, timeFormatValidator()])
      }
      nameCtrl?.updateValueAndValidity();
      codeCtrl?.updateValueAndValidity();
      iconCtrl?.updateValueAndValidity();
      hoursCtrl?.updateValueAndValidity();
      this.applySlotValidators(shiftGroup, shiftType, this.nonContinuousDuty, this.selectedDutyType);
    });
  }

  dutyCheckBoxOption(field:string, event:any){
    if(field === 'picketDuty' || field === 'managersDuty'){
      if(event?.checked === false){
        this.shiftsValidation('clear-validators')
        this.revertShiftFormArray()
      }
      else{
        if(this.selectedDutyType === 'DAY'){
        this.filterShiftFormArray?.()
        }
        if (this.shiftsFormArray?.length > 0) {
          const shift = this.shiftsFormArray.at(0);
          shift?.get('selected')?.setValue(true);
        }
        this.shiftsValidation('set-validators')
      }
      this.updateManagersDutyState();
      this.resetPermanentNightIconIfNotApplicable();
    }
  }

    private applyBreakTimeValidators(group: FormGroup): void {
    const breakStart = group.get('breakStartTime');
    const breakEnd = group.get('breakEndTime');
    if (!breakStart || !breakEnd) return;

    // break window belongs to FULL_DAY_DUTY only
    if (group.get('shiftType')?.value !== 'FULL_DAY_DUTY') {
      breakStart.clearValidators();
      breakEnd.clearValidators();
      breakStart.updateValueAndValidity({ emitEvent: false });
      breakEnd.updateValueAndValidity({ emitEvent: false });
      return;
    }

    const lowerField = 'firstSlotStartTime';
    const upperField = this.nonContinuousDuty ? 'secondSlotEndTime' : 'firstSlotEndTime';

    const startValidators: ValidatorFn[] = [
      breakTimeRangeValidator(lowerField, upperField, 'breakEndTime', true),
    ];
    const endValidators: ValidatorFn[] = [
      breakTimeRangeValidator(lowerField, upperField, 'breakStartTime', false),
    ];

    // entering one bound makes the other required
    if (breakEnd.value) startValidators.unshift(Validators.required);
    if (breakStart.value) endValidators.unshift(Validators.required);

    breakStart.setValidators(startValidators);
    breakEnd.setValidators(endValidators);
    breakStart.updateValueAndValidity({ emitEvent: false });
    breakEnd.updateValueAndValidity({ emitEvent: false });
  }

  private prefillBreakTimes(group: FormGroup): void {
    if (group.get('shiftType')?.value !== 'FULL_DAY_DUTY') return;
    if (!this.nonContinuousDuty) return; // continuous: user owns the window

    const breakStart = group.get('breakStartTime');
    const breakEnd = group.get('breakEndTime');
    const firstEnd = group.get('firstSlotEndTime')?.value;
    const secondStart = group.get('secondSlotStartTime')?.value;

    // Non-admins: the window IS the slot gap, so re-sync on every slot change.
    // APP_ADMIN keeps the old seed-only behaviour so a manual correction isn't overwritten.
    const overwrite = !this.isAppAdmin;

    if (breakStart && firstEnd && (overwrite || !breakStart.value)) {
      breakStart.setValue(firstEnd, { emitEvent: false });
    }
    if (breakEnd && secondStart && (overwrite || !breakEnd.value)) {
      breakEnd.setValue(secondStart, { emitEvent: false });
    }
  }

  /** Derive breakHours (duration) from the break window. FULL_DAY_DUTY only. */
  private computeBreakHours(group: FormGroup): void {
    if (group.get('shiftType')?.value !== 'FULL_DAY_DUTY') return;

    const breakHoursCtrl = group.get('breakHours');
    if (!breakHoursCtrl) return;

    const start = group.get('breakStartTime')?.value;   // "HH:mm"
    const end = group.get('breakEndTime')?.value;        // "HH:mm"

    const windowIncomplete =
      !start || !end ||
      group.get('breakStartTime')?.invalid ||
      group.get('breakEndTime')?.invalid;

    if (windowIncomplete) {
      if (this.breakHoursInitialised.has(group)) {
        breakHoursCtrl.setValue('', { emitEvent: false });
        breakHoursCtrl.updateValueAndValidity({ emitEvent: false });
      }
      return;
    }

    const toMinutes = (t: string) => {
      const [h, m] = t.split(':').map(Number);
      return h * 60 + m;
    };

    let mins = toMinutes(end) - toMinutes(start);
    if (mins < 0) mins += 1440;   // overnight wrap

    const h = Math.floor(mins / 60);
    const m = mins % 60;

    let duration = '';
    if (h > 0) duration += `${h}h`;
    if (m > 0) duration += `${h > 0 ? ' ' : ''}${m}m`;
    if (!duration) duration = '0m';

    breakHoursCtrl.setValue(duration, { emitEvent: false });
    breakHoursCtrl.updateValueAndValidity({ emitEvent: false });
  }

  /**
   * Locks the break window for every role except APP_ADMIN on non-continuous duties.
   * `readonly` does not block the native time picker in Chromium, so the controls are
   * disabled instead. submitForm() reads getRawValue(), so the derived break window
   * still reaches the payload.
   */
  private applyBreakTimeAccess(group: FormGroup): void {
    if (group.get('shiftType')?.value !== 'FULL_DAY_DUTY') return;
    // group already fully disabled (no duty edit rights) - leave it untouched
    if (group.disabled) return;

    ['breakStartTime', 'breakEndTime'].forEach((field) => {
      const ctrl = group.get(field);
      if (!ctrl) return;
      if (this.breakTimeReadOnly) {
        if (ctrl.enabled) ctrl.disable({ emitEvent: false });
      } else if (ctrl.disabled) {
        ctrl.enable({ emitEvent: false });
      }
    });
  }

  /** Break window is derived from the slot gap on non-continuous duties. APP_ADMIN may correct it. */
  get breakTimeReadOnly(): boolean {
    return this.nonContinuousDuty && !this.isAppAdmin;
  }

  /** Break hours is always derived from the break window. APP_ADMIN may correct it. */
  get breakHoursReadOnly(): boolean {
    return !this.isAppAdmin;
  }

  /** Same rule as the rest of the dialog: can the current user edit this duty? */
  get isDutyEditable(): boolean {
    return this.canEditDuty && (!this.isDutyMappedToAnyLocationDepartment || this.isAdmin);
  }

  /** Paid break only exists on a continuous FULL_DAY_DUTY (a non-continuous gap is never paid). */
  showPaidBreak(group: AbstractControl | null): boolean {
    return group?.get('shiftType')?.value === 'FULL_DAY_DUTY' && !this.nonContinuousDuty;
  }

  /** Mirrors the paid-time preview into the local `hours` control (decimal, e.g. 9.0 / 8.4). Not sent on save. */
  private syncHours(group: FormGroup): void {
    if (this.nonContinuousDuty) return; // non-continuous hours (slot 1 + slot 2) stay as returned by the backend
    const m = /^(\d+):(\d{2})/.exec(this.getPaidTimeLabel(group));
    if (!m) return;
    const decimal = Math.round((+m[1] + +m[2] / 60) * 100) / 100;
    group.get('hours')?.setValue(decimal, { emitEvent: false });
  }

  /** Live preview of the hours the backend stores: span - break, break kept when paid. */
  getPaidTimeLabel(group: AbstractControl | null): string {
    if (!group) return '–';
    const v = (group as FormGroup).getRawValue();
    const toMin = (t: string): number | null => {
      if (!t) return null;
      const [h, m] = t.split(':').map(Number);
      return isNaN(h) || isNaN(m) ? null : h * 60 + m;
    };
    const start = toMin(v.firstSlotStartTime);
    const end = toMin(v.firstSlotEndTime);
    if (start === null || end === null) return '–';

    let span = end - start;
    if (span <= 0) span += 1440; // overnight duty
    const breakMin = v.paidBreak ? 0 : this.parseBreakHours(v.breakHours || '');
    const paid = Math.max(span - breakMin, 0);

    return `${Math.floor(paid / 60)}:${String(paid % 60).padStart(2, '0')} h`;
  }

  /* ------------------------------------------------------------------
     Permanent night icon (NIGHT full-day shift only)
  ------------------------------------------------------------------ */

  /** Panel is offered only for a plain NIGHT duty (not picket, not manager). */
  get isPermanentNightApplicable(): boolean {
    const form = this.addDutyForm?.getRawValue();
    return this.selectedDutyType === 'NIGHT' && !form?.picketDuty && !form?.managersDuty;
  }

  /** NIGHT shift group (the night block always uses the first shift). */
  get permanentNightGroup(): FormGroup | null {
    return (this.shiftsFormArray?.at(0) as FormGroup) ?? null;
  }

  get isPermanentNightIconEnabled(): boolean {
    return !!this.permanentNightGroup?.get('permanentNightIconEnabled')?.value;
  }

  /** Toggle on → icon or colour required. */
  private permanentNightIconValidator: ValidatorFn = (group: AbstractControl) => {
    if (!this.isPermanentNightApplicable || !group.get('permanentNightIconEnabled')?.value) return null;
    const hasIcon = !!group.get('permanentNightIcon')?.value || !!group.get('permanentNightColourCode')?.value;
    return hasIcon ? null : { permanentNightIconRequired: true };
  };

  onPermanentNightToggle(checked: boolean): void {
    const group = this.permanentNightGroup;
    if (!group) return;
    group.get('permanentNightIconEnabled')?.setValue(checked);
    if (!checked) {
      this.clearPermanentNightIcon(group);
    }
    group.updateValueAndValidity();
    this.addDutyForm.markAsDirty();
  }

  onPermanentNightIconChange(selection: { icon: string | null; color: string | null; iconType: string | null; iconColour: string | null }): void {
    const group = this.permanentNightGroup;
    if (!group) return;
    group.patchValue({
      permanentNightIcon: selection.icon ?? '',
      permanentNightIconType: selection.iconType ?? '',
      permanentNightIconColour: selection.iconColour ?? '',
      permanentNightColourCode: selection.color ?? null,
    });
    group.updateValueAndValidity();
    this.addDutyForm.markAsDirty();
  }

  /** Switching to DAY / picket / manager removes the permanent night icon. */
  private resetPermanentNightIconIfNotApplicable(): void {
    if (this.isPermanentNightApplicable) return;
    this.shiftsFormArray?.controls.forEach((g) => {
      if (g.get('permanentNightIconEnabled')?.value) {
        g.get('permanentNightIconEnabled')?.setValue(false, { emitEvent: false });
        this.clearPermanentNightIcon(g as FormGroup);
      }
      g.updateValueAndValidity({ emitEvent: false });
    });
  }

  private clearPermanentNightIcon(group: FormGroup): void {
    group.patchValue(
      { permanentNightIcon: '', permanentNightIconType: '', permanentNightIconColour: '', permanentNightColourCode: null },
      { emitEvent: false }
    );
  }

  /** Payload fields; false + nulls when the duty is not a plain NIGHT duty or the toggle is off. */
  private mapPermanentNightIcon(shift: any, applicable: boolean): any {
    const on = applicable && !!shift?.permanentNightIconEnabled
      && !!(shift?.permanentNightIcon || shift?.permanentNightColourCode);
    return {
      permanentNightIconEnabled: on,
      permanentNightIcon: on ? shift.permanentNightIcon || null : null,
      permanentNightIconType: on ? shift.permanentNightIconType || null : null,
      permanentNightIconColour: on ? shift.permanentNightIconColour || null : null,
      permanentNightColourCode: on ? shift.permanentNightColourCode || null : null,
    };
  }

  /* ------------------------------------------------------------------
     Location policy & statutory break / duty hours compliance
  ------------------------------------------------------------------ */

  private extractLocationId(raw: any): string | null {
    if (!raw) return null;
    if (typeof raw === 'string') {
      const trimmed = raw.trim();
      return trimmed.length > 0 ? trimmed : null;
    }
    if (typeof raw === 'object') {
      const candidate = raw.id ?? raw.locationId ?? raw.locId ?? null;
      if (typeof candidate === 'string' && candidate.trim().length > 0) {
        return candidate.trim();
      }
    }
    return null;
  }

  private loadLocationPolicy(): void {
    const candidate =
      this.extractLocationId(this.editFormData?.selectedLocationId) ||
      this.extractLocationId(this.editFormData?.locationId) ||
      this.extractLocationId(this.editFormData?.editData?.locationId) ||
      this.extractLocationId(this.sharedDataService.locationId) ||
      (typeof window !== 'undefined'
        ? this.extractLocationId(sessionStorage.getItem('selLocationId')) ||
          this.extractLocationId(sessionStorage.getItem('userLocationId')) ||
          this.extractLocationId(sessionStorage.getItem('locationId'))
        : null);

    if (candidate) {
      this.fetchLocationPolicy(candidate);
    } else {
      this.sharedDataService.selectedLocId$
        .pipe(takeUntil(this.destroy$))
        .subscribe((val: any) => {
          const id = this.extractLocationId(val);
          if (id && !this.locationPolicy) {
            this.fetchLocationPolicy(id);
          }
        });
    }
  }

  private fetchLocationPolicy(locId: string): void {
    this.locationService
      .fetchLocationPolicy(locId)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: any) => {
          if (res?.status === 200) {
            this.locationPolicy = res.body ?? res;
          } else if (res && !res.status) {
            this.locationPolicy = res;
          }
          this.revalidateBreakHours();
        },
        error: (err: any) => {
          console.error('Failed to load location policy', err);
        },
      });
  }

  private timeToMinutes(t: any): number | null {
    if (!t || typeof t !== 'string') return null;
    const parts = t.trim().split(':');
    if (parts.length < 2) return null;
    const h = Number(parts[0]);
    const m = Number(parts[1]);
    return isNaN(h) || isNaN(m) ? null : h * 60 + m;
  }

  private parseBreakMinutes(val: any): number {
    if (!val) return 0;
    if (typeof val === 'number') return val;
    const str = String(val).trim();
    if (/^\d+$/.test(str)) return parseInt(str, 10);
    const hmMatch = str.match(/^(\d{1,2}):(\d{2})$/);
    if (hmMatch) {
      return parseInt(hmMatch[1], 10) * 60 + parseInt(hmMatch[2], 10);
    }
    const hMatch = str.match(/(\d+)\s*h/i);
    const mMatch = str.match(/(\d+)\s*m/i);
    const h = hMatch ? parseInt(hMatch[1], 10) : 0;
    const m = mMatch ? parseInt(mMatch[1], 10) : 0;
    return h * 60 + m;
  }

  private formatHoursMinutes(minutes: number): string {
    const safeMin = Math.max(0, minutes || 0);
    const h = Math.floor(safeMin / 60);
    const m = safeMin % 60;
    return `${h}:${String(m).padStart(2, '0')} h`;
  }

  /**
   * Break is required only when the location's break rules are on and the net working time
   * reaches a tier (e.g. over 5:30 h). Otherwise it stays optional.
   */
  private breakRequiredValidator: ValidatorFn = (ctrl: AbstractControl) => {
    const group = ctrl.parent;
    if (!group || ctrl.value) return null;
    const info = this.getComplianceInfo(group);
    return info.enforceBreaks && info.minBreakMinutes > 0 ? { required: true } : null;
  };

  /** Re-check break hours once the location policy has loaded. */
  private revalidateBreakHours(): void {
    if (!this.addDutyForm) return; // policy arrived before the form was built
    this.shiftsFormArray.controls.forEach((g) => g.get('breakHours')?.updateValueAndValidity({ emitEvent: false }));
    this.addDutyForm.updateValueAndValidity({ emitEvent: false });
  }

  /** Day / night time-window error, as set on the slot controls by timeRangeValidator. */
  getSlotRangeError(group: AbstractControl | null): 'day' | 'night' | null {
    if (!group) return null;
    const slots = ['firstSlotStartTime', 'firstSlotEndTime', 'secondSlotStartTime', 'secondSlotEndTime'];
    const has = (err: string) => slots.some((k) => group.get(k)?.hasError(err));
    if (has('invalidDaySlot')) return 'day';
    if (has('invalidNightSlot')) return 'night';
    return null;
  }

  /** Display only (values stay in minutes), same style as Break hours: "30m", "1h", "1h 30m". */
  private formatBreakDuration(minutes: number): string {
    const safeMin = Math.max(0, Math.round(minutes || 0));
    const h = Math.floor(safeMin / 60);
    const m = safeMin % 60;
    if (h === 0) return `${m}m`;
    return m === 0 ? `${h}h` : `${h}h ${m}m`;
  }

  get isNonCompliant(): boolean {
    if (this.addDutyForm?.get('picketDuty')?.value) {
      return false;
    }

    if (this.selectedDutyType === 'DAY' && !this.addDutyForm?.get('managersDuty')?.value) {
      const selectedShifts = this.shiftsFormArray?.controls.filter(
        (ctrl) => ctrl.get('selected')?.value
      );
      if (selectedShifts && selectedShifts.length > 0) {
        return selectedShifts.some(
          (ctrl) => !this.getComplianceInfo(ctrl).isCompliant
        );
      }
      const currentShift = this.shiftsFormArray?.at(this.selectedTabIndex);
      if (currentShift) {
        return !this.getComplianceInfo(currentShift).isCompliant;
      }
      return false;
    }

    const shift0 = this.shiftsFormArray?.at(0);
    if (shift0) {
      return !this.getComplianceInfo(shift0).isCompliant;
    }

    return false;
  }

  getComplianceInfo(group: AbstractControl | null) {
    // Only checked when the location policy defines it (Richtlinien → Dienste & Pausen)
    const rawMaxDuty = this.locationPolicy?.maxDutyHours;
    const hasMaxDuty = rawMaxDuty !== undefined && rawMaxDuty !== null && rawMaxDuty !== '';
    const maxDutyMinutes = hasMaxDuty ? Number(rawMaxDuty) : 0;
    const breakRules = this.locationPolicy?.breakRules;
    const policyEnforce =
      breakRules?.enforce ?? this.locationPolicy?.enforceStatutoryBreaks ?? false;

    const formGroup = group as FormGroup;
    const v = formGroup?.getRawValue();
    const shiftType = v?.shiftType;

    const hasBreakField =
      shiftType === 'FULL_DAY_DUTY' &&
      (formGroup?.contains('breakHours') || formGroup?.contains('breakStartTime'));

    const enforceBreaks = policyEnforce && hasBreakField;

    const def = {
      dutyLengthMinutes: 0,
      dutyLengthFormatted: '0:00 h',
      maxDutyMinutes,
      maxDutyFormatted: this.formatHoursMinutes(maxDutyMinutes),
      netWorkingMinutes: 0,
      netWorkingFormatted: '0:00 h',
      plannedBreakMinutes: 0,
      plannedBreakFormatted: this.formatBreakDuration(0),
      minBreakMinutes: 0,
      minBreakFormatted: this.formatBreakDuration(0),
      isDutyLengthCompliant: true,
      isBreakCompliant: true,
      isCompliant: true,
      enforceBreaks,
      hasMaxDuty,
      hasPolicy: hasMaxDuty || enforceBreaks,
      hasTimes: false,
    };

    if (!group) return def;

    let startStr: string = '';
    let endStr: string = '';

    if (shiftType === 'SECOND_HALF_DAY_DUTY') {
      startStr = v?.secondSlotStartTime;
      endStr = v?.secondSlotEndTime;
    } else if (
      this.nonContinuousDuty &&
      (shiftType === 'FULL_DAY_DUTY' || this.selectedDutyType !== 'DAY')
    ) {
      startStr = v?.firstSlotStartTime;
      endStr = v?.secondSlotEndTime;
    } else {
      startStr = v?.firstSlotStartTime;
      endStr = v?.firstSlotEndTime;
    }

    const startMin = this.timeToMinutes(startStr);
    const endMin = this.timeToMinutes(endStr);
    const hasTimes = startMin !== null && endMin !== null;

    let dutyLengthMinutes = 0;
    if (hasTimes) {
      let span = endMin - startMin;
      if (span <= 0) span += 1440; // wrap over midnight
      dutyLengthMinutes = span;
    }

    let plannedBreakMinutes = 0;
    if (
      shiftType === 'FIRST_HALF_DAY_DUTY' ||
      shiftType === 'SECOND_HALF_DAY_DUTY'
    ) {
      plannedBreakMinutes = 0;
    } else if (this.nonContinuousDuty) {
      const bStart = this.timeToMinutes(v?.breakStartTime);
      const bEnd = this.timeToMinutes(v?.breakEndTime);
      if (bStart !== null && bEnd !== null) {
        let bSpan = bEnd - bStart;
        if (bSpan < 0) bSpan += 1440;
        plannedBreakMinutes = bSpan;
      } else {
        const slot1End = this.timeToMinutes(v?.firstSlotEndTime);
        const slot2Start = this.timeToMinutes(v?.secondSlotStartTime);
        if (slot1End !== null && slot2Start !== null) {
          let gap = slot2Start - slot1End;
          if (gap < 0) gap += 1440;
          plannedBreakMinutes = gap;
        } else if (v?.breakHours) {
          plannedBreakMinutes = this.parseBreakMinutes(v.breakHours);
        }
      }
    } else {
      const bStart = this.timeToMinutes(v?.breakStartTime);
      const bEnd = this.timeToMinutes(v?.breakEndTime);
      if (bStart !== null && bEnd !== null) {
        let bSpan = bEnd - bStart;
        if (bSpan < 0) bSpan += 1440;
        plannedBreakMinutes = bSpan;
      } else if (v?.breakHours) {
        plannedBreakMinutes = this.parseBreakMinutes(v.breakHours);
      }
    }

    const netWorkingMinutes = hasTimes
      ? Math.max(0, dutyLengthMinutes - plannedBreakMinutes)
      : 0;

    let rawTiers: any[] = breakRules?.tiers ?? [];
    if (!Array.isArray(rawTiers) || rawTiers.length === 0) {
      rawTiers = [
        { thresholdMinutes: 330, minBreakMinutes: 15 },
        { thresholdMinutes: 420, minBreakMinutes: 30 },
        { thresholdMinutes: 540, minBreakMinutes: 60 },
      ];
    }

    const tiers = rawTiers
      .map((t) => {
        let thresh = t.thresholdMinutes;
        if (thresh === undefined || thresh === null) {
          thresh =
            typeof t.threshold === 'string' && t.threshold.includes(':')
              ? this.timeToMinutes(t.threshold)
              : Number(t.threshold ?? 0);
        }
        const minBr = t.minBreakMinutes ?? t.minBreak ?? 0;
        return {
          thresholdMinutes: Number(thresh ?? 0),
          minBreakMinutes: Number(minBr ?? 0),
        };
      })
      .sort((a, b) => a.thresholdMinutes - b.thresholdMinutes);

    let minBreakMinutes = 0;
    if (hasTimes) {
      for (const tier of tiers) {
        if (netWorkingMinutes > tier.thresholdMinutes) {
          minBreakMinutes = tier.minBreakMinutes;
        }
      }
    }

    const isDutyLengthCompliant =
      !hasMaxDuty || !hasTimes || dutyLengthMinutes <= maxDutyMinutes;
    const isBreakCompliant =
      !hasTimes || plannedBreakMinutes >= minBreakMinutes;
    const isCompliant = enforceBreaks
      ? isDutyLengthCompliant && isBreakCompliant
      : isDutyLengthCompliant;

    return {
      dutyLengthMinutes,
      dutyLengthFormatted: this.formatHoursMinutes(dutyLengthMinutes),
      maxDutyMinutes,
      maxDutyFormatted: this.formatHoursMinutes(maxDutyMinutes),
      netWorkingMinutes,
      netWorkingFormatted: this.formatHoursMinutes(netWorkingMinutes),
      plannedBreakMinutes,
      plannedBreakFormatted: this.formatBreakDuration(plannedBreakMinutes),
      minBreakMinutes,
      minBreakFormatted: this.formatBreakDuration(minBreakMinutes),
      isDutyLengthCompliant,
      isBreakCompliant,
      isCompliant,
      enforceBreaks,
      hasMaxDuty,
      hasPolicy: hasMaxDuty || enforceBreaks,
      hasTimes,
    };
  }
}
